<app-popover #popover [trigger]="null" [overlayClickable]="true" [fullscreenOnMobile]="true"
    class="md:max-w-[540px] xl:max-w-[480px] !p-0 !shadow-2xl" placement="right" align="start"
    (visibleChange)="onVisibleChange($event)">
    <ng-template #body>
        <div class="flex flex-col gap-3">
            <!-- Preview cards -->
            <div class="w-full rounded-t-md"
                style="background: linear-gradient(97.02deg, #FFAD8A -0.49%, #7A91FE 107.74%); padding: 30px 20px 0px 20px;">
                <div class="flex overflow-hidden">
                    <div class="flex-1 min-w-0 [&>svg]:w-full [&>svg]:h-auto [&>svg]:block"
                        [innerHTML]="GENERAL_AGENT_SVG.PROMPT_LIBRARY_PREVIEW | sanitizeHtml"></div>
                </div>
            </div>

            <!-- Title & description -->
            <div class="flex flex-col gap-1 px-6 mt-2">
                <h2 class="text-base font-bold text-gray-900">Prompt Library</h2>
                <p class="text-sm text-gray-600">A shared library of ready-made AI prompts for common construction
                    tasks. No prompt-writing skills needed — just pick, use, and get great results.</p>
            </div>

            <!-- Best uses -->
            <div class="flex flex-col gap-3 px-6 pb-4">
                <p class="text-base font-semibold text-gray-900">Best uses</p>
                <div class="grid grid-cols-2 gap-x-6 gap-y-2 relative">
                    <div class="absolute inset-y-0 left-1/2 w-px bg-gray-200"></div>
                    <div class="flex items-center gap-2">
                        <span
                            class="flex-shrink-0 rounded-full bg-arena-orange-100 p-1.5 flex items-center justify-center"><span
                                class="w-1 h-1 bg-arena-orange rotate-45 block"></span></span>
                        <span class="text-sm text-gray-700">Turn vague requests into structured prompts instantly</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span
                            class="flex-shrink-0 rounded-full bg-arena-orange-100 p-1.5 flex items-center justify-center"><span
                                class="w-1 h-1 bg-arena-orange rotate-45 block"></span></span>
                        <span class="text-sm text-gray-700">Get prompt suggestions for tasks you've done before</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span
                            class="flex-shrink-0 rounded-full bg-arena-orange-100 p-1.5 flex items-center justify-center"><span
                                class="w-1 h-1 bg-arena-orange rotate-45 block"></span></span>
                        <span class="text-sm text-gray-700">Reuse one prompt template across multiple similar
                            documents</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span
                            class="flex-shrink-0 rounded-full bg-arena-orange-100 p-1.5 flex items-center justify-center"><span
                                class="w-1 h-1 bg-arena-orange rotate-45 block"></span></span>
                        <span class="text-sm text-gray-700">Stop rewriting the same prompts from scratch every
                            time</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span
                            class="flex-shrink-0 rounded-full bg-arena-orange-100 p-1.5 flex items-center justify-center"><span
                                class="w-1 h-1 bg-arena-orange rotate-45 block"></span></span>
                        <span class="text-sm text-gray-700">Save and share prompts with any department</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span
                            class="flex-shrink-0 rounded-full bg-arena-orange-100 p-1.5 flex items-center justify-center"><span
                                class="w-1 h-1 bg-arena-orange rotate-45 block"></span></span>
                        <span class="text-sm text-gray-700">Built for back-office teams doing the same tasks
                            daily</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <span
                            class="flex-shrink-0 rounded-full bg-arena-orange-100 p-1.5 flex items-center justify-center"><span
                                class="w-1 h-1 bg-arena-orange rotate-45 block"></span></span>
                        <span class="text-sm text-gray-700">Use the same AI workflow across all construction
                            teams</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <div class="flex justify-end gap-3 w-full px-6 py-3 border-t border-gray-200">
            <app-button variant="outlined" severity="contrast" (clicked)="onGotIt()">Got it</app-button>
            <app-button severity="primary" (clicked)="onCheckPrompts()">Check prompts</app-button>
        </div>
    </ng-template>
</app-popover>